import { render, staticRenderFns } from "./PalletsEn.vue?vue&type=template&id=422fd118&scoped=true&"
import script from "./PalletsEn.vue?vue&type=script&lang=js&"
export * from "./PalletsEn.vue?vue&type=script&lang=js&"
import style0 from "./PalletsEn.vue?vue&type=style&index=0&id=422fd118&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422fd118",
  null
  
)

export default component.exports